// App
const DashboardWrapper = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "home" */ '@/components/DashboardWrapper.vue');
const HomeView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "home" */ '@/views/Dashboard/HomeView.vue');
const DashboardView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "home" */ '@/views/Dashboard/DashboardView.vue');
const EstrategicoView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "home" */ '@/views/Dashboard/EstrategicoView.vue');

// Processos
const ProcessoKanbanView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "processos" */ '@/views/Processos/ProcessoKanbanView.vue');
const AberturaProcessoView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "processos" */ '@/views/Processos/AberturaProcessoView.vue');
const ProcessoListagemView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "processos" */ '@/views/Processos/ProcessoListagemView.vue');
const DespesasImportacaoView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "processos" */ '@/views/Processos/DespesasImportacaoView.vue');

// KPIs
const UsuariosView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "usuarios" */ '@/views/Usuarios/UsuariosView.vue');

// Agendamento Relatórios
const AgendamentoRelatorioView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "agendamento_relatorios" */ '@/views/AgendamentoRelatorio/AgendamentoRelatorioView.vue');

// Estoque
const EstoqueView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Estoque" */ '@/views/Armazenamento/Estoque/EstoqueView.vue');

// Ged
const GedView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "ged" */ '@/views/Usuarios/GedView.vue');

// Armazém
const ArmazemPrevisao = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "expedicao" */ '@/views/Armazenamento/Armazem/PrevisaoDemandaDomesticaView.vue');
const AcuraciaEstoque = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "expedicao" */ '@/views/Armazenamento/Acuracia/AcuraciaView.vue');
const AcuraciaArmazem = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "expedicao" */ '@/views/Armazenamento/Acuracia/AcuraciaArmazemView.vue');

// Financeiro
const CambioView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cambio" */ '@/views/Financeiro/CambioView.vue');

// Gestão de LIs
const GestaoLIView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "gestaoLI" */ '@/views/GestaoLI/GestaoLIView.vue');

// Fretes
const FretesView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "fretes" */ '@/views/Transportes/FretesView.vue');

// Performance Frete
const PerformanceView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "performance" */ '@/views/Transportes/PerformanceView.vue');

// Analise de Frete
const AnaliseView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "analiseFrete" */ '@/views/Transportes/AnaliseView.vue');

// Processos Pendentes
const ProcessosPendentesView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "processosPendentes" */ '@/views/Processos/ProcessosPendentesView.vue');

// Containers
const ContainersView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Containers" */ '@/views/Containers/ContainersView.vue');

// Custos de armazém
const CustosArmazemView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "custos-armazem" */ '@/views/Armazenamento/Armazem/CustosView.vue');

// Empresas
const EmpresasView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "empresas" */ '@/views/Empresas/EmpresasView.vue');

// Incentivo Fiscal
const IncentivoFiscalView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "incentivo-fiscal" */ '@/views/Relatorios/IncentivoFiscalView.vue');

// CadastroBasicos
const CadastroBasicoView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cadastro-basico" */ '@/views/CadastrosBasicos/CadastroBasicoMainView.vue');

const CrcView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "incentivo-fiscal" */ '@/views/CRC/CrcView.vue');

// Simulação
const SimulacaoView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "simulacao" */ '@/views/Simulacao/SimulacaoView.vue');

// Processos afiliados (Usuário consultor)
const ProcessosParceirosView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "processosParceiros" */ '@/views/Processos/ProcessosParceirosView.vue');

// Processos afiliados (Usuário consultor)
const ProcessosComissaoView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "processosComissao" */ '@/views/Processos/ProcessosComissaoView.vue');

const DashboardContainerView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "DashboardContainerView" */ '@/views/Containers/DashboardContainersView.vue');

// Funcionalidades Internas Trust
const TarefasView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "tarefas" */ '@/views/Interno/Tarefas/TarefasView.vue'); // Gestao de Tarefas
const MercadoHojeView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "MercadoHojeView" */ '@/views/Interno/MercadoHoje/MercadoHojeView.vue');
const RepliquesView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "RepliquesView" */ '@/views/Repliques/RepliquesView.vue');
const RepliquesNFeView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "RepliquesNFeView" */ '@/views/RepliquesNFe/RepliquesNFeView.vue');

// Distribuição
const DistribuicaoView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "DistribuicaoView" */ '@/views/Distribuicao/DistribuicaoView.vue');

// Inventario
const InventarioView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "InventarioView" */ '@/views/Inventario/InventarioView.vue');

// Notícias para clientes
const NoticiasClienteView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "NoticiasClienteView" */ '@/views/NoticiasCliente/NoticiasClienteView.vue');

// Control Tower Comex
const ControlTowerComexView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "ControlTowerComex" */ '@/views/ControlTowerComex/ControlTowerComexView.vue');

const DeclaracaoImportacaoView = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "DeclaracaoImportacaoView" */ '@/views/Processos/DeclaracaoImportacaoView.vue');

const routes = [
  {
    path: '/',
    component: DashboardWrapper,
    children: [
      {
        path: '/',
        name: 'Home',
        component: HomeView,
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: DashboardView,
      },
      {
        path: '/estrategico',
        name: 'estrategico',
        component: EstrategicoView,
        meta: { requiresRole: ['ADMINISTRADOR', 'ANALISTA'] },
      },
      {
        path: '/custos-armazem',
        name: 'CustosArmazem',
        component: CustosArmazemView,
      },
      // Simulação
      {
        path: '/simulacao',
        name: 'Simulacao',
        component: SimulacaoView,
        meta: { requiresRole: ['ADMINISTRADOR', 'ANALISTA'] },
      },

      // Internos Trust

      // Gestao de Tarefas
      {
        path: '/tarefas',
        name: 'Tarefas',
        component: TarefasView,
        meta: { requiresRole: ['ADMINISTRADOR', 'ANALISTA'] },
      },

      // Mercado Hoje
      {
        path: '/mercado-hoje',
        name: 'mercadoHoje',
        component: MercadoHojeView,
        meta: { requiresRole: ['ADMINISTRADOR', 'ANALISTA'] },
      },

      // Processos
      {
        path: '/processos/kanban',
        name: 'ProcessosKanban',
        component: ProcessoKanbanView,
      },
      {
        path: '/processos/solicitacao',
        name: 'AberturaProcesso',
        component: AberturaProcessoView,
      },
      {
        path: '/processos/listagem',
        name: 'ListagemProcesso',
        component: ProcessoListagemView,
      },
      {
        path: '/processos/pendentes',
        name: 'processosPendentes',
        component: ProcessosPendentesView,
      },
      {
        path: '/processos/despesasImportacao',
        name: 'despesasImportacao',
        component: DespesasImportacaoView,
        meta: { requiresRole: ['ADMINISTRADOR', 'ANALISTA', 'CLIENTE_GESTOR'] },
      },

      // Usuários
      {
        path: '/usuarios/:id?',
        name: 'ListarUsuarios',
        component: UsuariosView,
      },

      // Agendamento
      {
        path: '/agendamento-relatorios',
        name: 'AgendamentoRelatorios',
        component: AgendamentoRelatorioView,
      },

      // Notícias para Clientes
      {
        path: '/noticias-clientes',
        name: 'NoticiasClientes',
        component: NoticiasClienteView,
        meta: { requiresRole: ['ADMINISTRADOR', 'ANALISTA'] },
      },

      // Estoque
      {
        path: '/estoque',
        name: 'Estoque',
        component: EstoqueView,
      },

      // GED
      {
        path: '/ged',
        name: 'Ged',
        component: GedView,
      },

      // Armazém
      {
        path: '/previsao-demanda-domestica',
        name: 'PrevisaoDemandaDomestica',
        component: ArmazemPrevisao,
        meta: { requiresRole: ['ADMINISTRADOR', 'ANALISTA'] },
      },
      {
        path: '/acuracia-estoque',
        name: 'acuraciaEstoque',
        component: AcuraciaEstoque,
        meta: { requiresRole: ['ADMINISTRADOR'] },
      },
      {
        path: '/acuracia-armazem',
        name: 'acuraciaArmazem',
        component: AcuraciaArmazem,
        meta: { requiresRole: ['ADMINISTRADOR'] },
      },

      // Financeiro
      {
        path: '/financeiro',
        name: 'Financeiro',
        component: CambioView,
      },

      // Gestão de LIs
      {
        path: '/gestao-li',
        name: 'GestaoLI',
        component: GestaoLIView,
      },
      {
        path: '/containers',
        name: 'Containers',
        component: ContainersView,
      },
      {
        path: 'dashboard-containers',
        name: 'DashboardContainers',
        component: DashboardContainerView,
      },
      // Empresas
      {
        path: '/empresas',
        name: 'Empresas',
        component: EmpresasView,
        meta: { requiresRole: ['ADMINISTRADOR', 'ANALISTA'] },
      },

      // Incentivo fiscal
      {
        path: '/incentivo-fiscal',
        name: 'incentivoFiscal',
        component: IncentivoFiscalView,
      },
      // Cadastros
      {
        path: '/cadastros',
        name: 'cadastrosBasicos',
        component: CadastroBasicoView,
      },
      // CRC
      {
        path: '/crc',
        name: 'crc',
        component: CrcView,
      },
      // Simulacao
      {
        path: '/simulacao',
        name: 'simulacao',
        component: SimulacaoView,
        meta: { requiresRole: ['ADMINISTRADOR', 'ANALISTA'] },
      },
      {
        path: '/processos-parceiros',
        name: 'processosParceiros',
        component: ProcessosParceirosView,
        meta: { requiresRole: ['CLIENTE_CONSULTOR', 'ADMINISTRADOR'] },
      },
      {
        path: '/processos-comissao',
        name: 'processosComissao',
        component: ProcessosComissaoView,
        meta: { requiresRole: ['ADMINISTRADOR', 'CLIENTE_CONSULTOR'] },
      },
      // Fretes
      {
        path: '/fretes',
        name: 'fretes',
        component: FretesView,
      },
      // Performance
      {
        path: '/fretes/performance',
        name: 'fretesPerformance',
        component: PerformanceView,
      },
      // Analise
      {
        path: '/fretes/analise',
        name: 'analiseFrete',
        component: AnaliseView,
        meta: { requiresRole: ['ADMINISTRADOR', 'ANALISTA'] },
      },
      // Distribuição
      {
        path: '/distribuicao',
        name: 'distribuicao',
        component: DistribuicaoView,
        meta: { requiresRole: ['ADMINISTRADOR', 'ANALISTA'] },
      },
      {
        path: '/repliques',
        name: 'repliques',
        component: RepliquesView,
        meta: { requiresRole: ['ADMINISTRADOR', 'ANALISTA'] },
      },
      {
        path: '/repliques-nfe',
        name: 'repliquesNFe',
        component: RepliquesNFeView,
        meta: { requiresRole: ['ADMINISTRADOR', 'ANALISTA'] },
      },
      {
        path: '/inventario',
        name: 'inventario',
        component: InventarioView,
      },
      {
        path: '/control-tower-comex',
        name: 'controlTowerComex',
        component: ControlTowerComexView,
      },
      {
        path: '/declaracao-importacao',
        name: 'declaracaoImportacao',
        component: DeclaracaoImportacaoView,
      },
      {
        path: '*',
        redirect: {
          name: 'Home',
        },
      },
    ],
  },
];

export default routes;
